import {
  createMySqlQueryRecord,
  deleteMySqlQueryRecord,
  fetchMySqlQueryList,
  fetchMySqlQueryListDemo2,
  updateMySqlQueryRecord,
} from "../../api/sqlServerDemoApi";
import type {
  MySqlQueryListItem,
  MySqlQueryListPage,
  MySqlQueryListParams,
  MySqlQueryRecordDeleteResult,
  MySqlQueryRecordMutation,
} from "../types";

/** MySQL 查询列表数据访问仓储。 */
export const mySqlQueryListRepo = {
  /** 查询列表数据。 */
  fetchList: async (params: MySqlQueryListParams): Promise<MySqlQueryListPage> => fetchMySqlQueryList(params),
  /** 创建记录。 */
  createRecord: async (payload: MySqlQueryRecordMutation): Promise<MySqlQueryListItem> =>
    createMySqlQueryRecord(payload),
  /** 更新记录。 */
  updateRecord: async (recordId: number, payload: MySqlQueryRecordMutation): Promise<MySqlQueryListItem> =>
    updateMySqlQueryRecord(recordId, payload),
  /** 删除记录。 */
  deleteRecord: async (recordId: number): Promise<MySqlQueryRecordDeleteResult> =>
    deleteMySqlQueryRecord(recordId),
};

export type {
  MySqlQueryListItem,
  MySqlQueryListPage,
  MySqlQueryListParams,
  MySqlQueryRecordMutation,
};


/** MySQL 查询列表 Demo2 数据访问仓储。 */
export const mySqlQueryListDemo2Repo = {
  /** 查询列表数据。 */
  fetchList: async (params: MySqlQueryListParams): Promise<MySqlQueryListPage> =>
    fetchMySqlQueryListDemo2(params),
  /** 创建记录。 */
  createRecord: async (payload: MySqlQueryRecordMutation): Promise<MySqlQueryListItem> =>
    createMySqlQueryRecord(payload),
  /** 更新记录。 */
  updateRecord: async (recordId: number, payload: MySqlQueryRecordMutation): Promise<MySqlQueryListItem> =>
    updateMySqlQueryRecord(recordId, payload),
  /** 删除记录。 */
  deleteRecord: async (recordId: number): Promise<MySqlQueryRecordDeleteResult> =>
    deleteMySqlQueryRecord(recordId),
};
